.signet-table-container {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.signet-table {
  border-collapse: collapse;
  font-family: 'Lato';
  font-weight: 400;
  width: 100%;
  box-shadow: none;
}

.signet-table-row {
  display: grid;
  grid-auto-columns: max-content;
  width: 100%;
  border-bottom: 1px solid #ddd;
  border-radius: 4px;
}

.signet-table-head,
.signet-table-cell {
  padding: 12px;
  width: 100%;
  white-space: nowrap;
}

.signet-table-cell {
  &.align-right {
    display: grid;
    justify-self: end;
  }

  &.align-left {
    display: grid;
    justify-self: start;
  }
}

.signet-table-head {
  font-weight: 600;

  &.align-right {
    display: grid;
    justify-self: end;
  }

  &.align-left {
    display: grid;
    justify-self: start;
  }
}
